import Layout from "@/components/shared/Layout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import Head from 'next/head'
import Link from "next/link";
import PeerstackImage from '../../public/images/Peerstack 1200x630.jpeg'
import ContactForm from '@/components/shared/ContactForm'
import ScholarshipCard from '@/components/shared/ScholarshipCard'
import ScrollAnimation from '@/components/shared/ScrollAnimation'

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale || "az")),
    },
  };
}

const Apply = () => {
  const { t } = useTranslation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  return (
    <Layout>
      <Head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>{t("meta-title")}</title>
        <meta name="keywords" content="peerstack tech" />
        <meta name="description" content={t("meta-description")} />
        <meta name="image" content={PeerstackImage.src} />
        <link rel="canonical" href="https://peerstack.tech" />
        <meta property="og:site_name" content="peerstack.tech" />
        <meta property="og:title" content={t("meta-title")} />
        <meta property="og:url" content="{{page_link}}" />
        <meta property="og:description" content={t("meta-description")} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={PeerstackImage.src} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t("meta-title")} />
        <meta name="twitter:url" content="{{page_link}}" />
        <meta name="twitter:description" content={t("meta-description")} />
        <meta name="twitter:image" content={PeerstackImage.src} />
        {/*<script*/}
        {/*  type="application/ld+json"*/}
        {/*  dangerouslySetInnerHTML={{*/}
        {/*    __html: JSON.stringify({*/}
        {/*      "@context": "https://schema.org",*/}
        {/*      "@type": "Organization",*/}
        {/*      name: "PeerStack",*/}
        {/*      alternateName: "PeerStack Tech",*/}
        {/*      url: "https://peerstack.tech",*/}
        {/*      logo: Logo.src,*/}
        {/*      contactPoint: {*/}
        {/*        "@type": "ContactPoint",*/}
        {/*        telephone: "50 999 88 77",*/}
        {/*        contactType: "customer service",*/}
        {/*        areaServed: "AZ",*/}
        {/*        availableLanguage: "Azerbaijani",*/}
        {/*      },*/}
        {/*      sameAs: ["https://peerstack.tech/", "https://peerstack.tech/"],*/}
        {/*    }),*/}
        {/*  }}*/}
        {/*/>*/}
      </Head>
      {isSubmitted ? (
        <div className="min-h-[80vh] flex flex-col items-center justify-center bg-white px-4">
          <h1 className="font-poppins text-center mb-[12px]">
            <span
              className="text-[32px] md:text-[140px] font-bold align-middle"
              style={{ color: "#1E3A8A" }}
            >
              {t("apply-page.success-title-primary")}
            </span>
            <span
              className="text-[32px] md:text-[140px] font-bold align-middle ml-1"
              style={{
                color: "transparent",
                WebkitTextStroke: "2px #64748b",
                paintOrder: "stroke fill",
              }}
            >
              {t("apply-page.success-title-secondary")}
            </span>
          </h1>
          <p className="text-[#121417] text-[16px] md:[24px] mb-[20px] text-center">
            {t("apply-page.success-description")}
          </p>
          <Link
            href="/"
            className="h-[48px] md:h-[56px] w-[250px] rounded-full flex items-center justify-center text-white font-medium bg-main-pink hover:bg-white hover:text-main-pink border border-main-pink transition-colors duration-300 ease-in-out"
          >
            {t("apply-page.success-go-home")}
          </Link>
        </div>
      ) : (
        <>
          <ContactForm onSuccess={() => setIsSubmitted(true)} showSuccessToast={false} hideImageOnMobile />
          <ScrollAnimation delay={100}>
            <ScholarshipCard />
          </ScrollAnimation>
        </>
      )}
    </Layout>
  );
};

export default Apply;